<template>
    <v-snackbar
      v-model="showMe"
      :bottom="bottom"
      :color="color"
      :left="left"
      :right="right"
      :top="top"
      :timeout="timeout"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      :absolute="absolute"
    >
      <span v-html="text"></span>
      <v-btn
        dark
        text
        @click="showMe = false"
      >
        Close
      </v-btn>
    </v-snackbar>
</template>

<script>
export default {
    name: 'messaging',
    props: {
        display: {
            type: Boolean,
            required: false,
            default: false
        },
        bottom: {
            type: Boolean,
            required: false,
            default: false
        },
        left: {
            type: Boolean,
            required: false,
            default: false
        },
        right: {
            type: Boolean,
            required: false,
            default: false
        },
        top: {
            type: Boolean,
            required: false,
            default: false
        },
        color: {
            type: String,
            required: false
        },
        timeout: {
            type: Number,
            required: false,
            default: 6000
        },
        mode: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: false
        },
        absolute: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function(){
        return {
            showMe: false
        }
    },
    methods: {},
    computed: {
        display_trigger: function(){
            return this.display;
        }
    },
    watch: {
        display_trigger: function(){
            if(this.display===true){
                this.showMe = true;
            }
            if(this.display===false){
                this.showMe = false;    
            }
        },
        showMe: function(){
            if(this.showMe===true){
                this.$emit('opened');
            }

            if(this.showMe===false){
                this.$emit('closed');
            }
        }
    }

}
</script>

<style module>

</style>